import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dover-alert-table',
  templateUrl: './dover-alert-table.component.html',
  styleUrls: ['./dover-alert-table.component.css']
})
export class DoverAlertTableComponent implements OnInit {

  constructor() { } 

  ngOnInit(): void { 
  } 

}
